import { ChevronLeft } from "lucide-react";
import { Button } from "@primitives/button";
import { useNavigationState } from "@/zustand/NavigationState";

export default function ChatDetailsHeader() {
  const toggleChatDetails = useNavigationState(
    (state) => state.toggleChatDetails,
  );
  return (
    <div className="h-chatDetailsHeaderHeight shrink-0">
      <div className="flex h-full items-center px-4 align-middle lg:px-6">
        <Button
          className="flex items-center align-middle"
          size="icon"
          variant="ghost"
          onClick={() => toggleChatDetails()}
        >
          <ChevronLeft />
        </Button>
      </div>
    </div>
  );
}
